const lemiesz = { t: 'Lemiesz', name: 'lemiesz', hint: { url: '/blade' }}
export default lemiesz